import { Component, OnInit, Inject, Optional } from '@angular/core';
import { EmailAddress } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';
import { emailAddressFormConfig } from '../email-address.component';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	selector: 'rpshared-email-address-dialog',
	templateUrl: './email-address-dialog.component.html',
	styleUrls: ['./email-address-dialog.component.css'],
})
export class EmailAddressDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(emailAddressFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly email: EmailAddress,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.email) {
			this.control.setValue(this.email);
		}
	}
}
